import { Transformer } from "../../../../Transformer/index.js";
import ApiAddressProgram from "../../../../Api/AddressProgram/AddressProgramOrderApi.js";
import ApiAdjustment from "../../../../Api/AddressProgram/AdjustmentApi.js";
import ApiAdjustmentComment from "../../../../Api/AddressProgram/AdjustmentCommentApi.js";
import store from "../../../../Frontends/Common/store";
import { Filters } from "@prospace/prospace-components-library";
import _ from "lodash";

export class DashboardService {
  constructor() {
    this.transformer = new Transformer();
    this.apiAddressProgram = new ApiAddressProgram();
    this.apiAdjustment = new ApiAdjustment();
    this.apiAdjustmentComment = new ApiAdjustmentComment();
    this.additionalFilter = {}
  }
  setFilter(filter) {
    this.additionalFilter = filter
  }
  async getKpi() {
    // filter
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      marsPeriodId: { and: [marsPeriod.id] },
      coverage:  { and: [true] },
    }
    if (this.isAgency()) {
      const userinfo = store.getters["userinfoStore/getUserinfo"]
      mainFilter.agencyId = { and: [userinfo.agencyLinkAgencyId] }
    }
    //if (Object.keys(this.additionalFilter).length > 0) {
    let filter = {...mainFilter,  ...this.additionalFilter }
    //}
    const query = Filters.getQuery(filter)
    // grouping
    const grouping = ["marsPeriodId"]
    return await this.transformer.getItem(this.apiAddressProgram, "getAddressProgramOrders", query, grouping);
  }
  isAgency() {
    const userinfo = store.getters["userinfoStore/getUserinfo"]
    return userinfo.agencyLinkType == "AGENCY"
  }
  async getOutletTotal() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      marsPeriodId: {and: [marsPeriod.id] },
    }
    
    let filter = {...mainFilter,  ...this.additionalFilter }
    
    const query = Filters.getQuery(filter)
    return await this.transformer.getItem(this.apiAddressProgram, "getAddressProgramOrdersCount", query);
  }
  async getStatusOrders() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      marsPeriodId: {and: [marsPeriod.id] },
      coverage:  {and: [true] }
    }
    
    let filter = {...mainFilter,  ...this.additionalFilter }
    
    const query = Filters.getQuery(filter)
    return await this.transformer.getItem(this.apiAddressProgram, "getOrdersStatusCount", query);
  }
  async getStatusAgency() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const filter = {
      marsPeriodId: {and: [marsPeriod.id] },
      coverage:  {and: [true] }
    }
    const query = Filters.getQuery(filter)
    return await this.transformer.getItem(this.apiAddressProgram, "getAddressProgramAgencyStatusCount", query);
  }

  async getStatusOutlets() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      marsPeriodId: {and: [marsPeriod.id] },
      coverage:  {and: [true] }
    }
    
    let filter = {...mainFilter,  ...this.additionalFilter }
    
    const query = Filters.getQuery(filter)
    return await this.transformer.getItem(this.apiAddressProgram, "getAddressProgramOrdersStatusCount", query);
  }
  async getAdjustment() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      MarsPeriodId: {and: [marsPeriod.id] },
      disabled:  {and: [false] }
    }
    let filter = {...mainFilter,  ...this.additionalFilter }

    const query = Filters.getQuery(filter)
    return await this.transformer.getItem(this.apiAdjustment, "getAdjustmentStatusCount", query);
  }
  async getComments() {
    const marsPeriod = store.getters["marsPeriodStore/getMarsPeriod"]
    const mainFilter = {
      adjustmentMarsPeriodId: {and: [marsPeriod.id] },
      adjustmentDisabled:  {and: [false] },
      disabled:  {and: [false] }
    }
    let filter = {...mainFilter,  ...this.additionalFilter }
    // Изменяем фильтр, т.к. в коомментариях корректировок названия полей другие, т.к. подтягиваются через связь с Adjustment
    if (filter.agencyId){
      filter.adjustmentAgencyId = filter.agencyId;
      delete filter.agencyId;
    }
    if (filter.kADLId){
      filter.adjustmentKADLId = filter.kADLId;
      delete filter.kADLId;
    }
    if (filter.channelId){
      filter.adjustmentChannelId = filter.channelId;
      delete filter.channelId;
    }
    if (filter.area){
      filter.adjustmentArea = filter.area;
      delete filter.area;
    }
    //TODO: top/skip parameters to getQuery
    const query = Filters.getQuery(filter, 'createdAt', 2).replace('top=0', 'top=10')
    return await this.transformer.getGrid(this.apiAdjustmentComment, "getAdjustmentComments", query);
  }
  getPercent(fact, plan) {
    let result = (fact / plan) * 100;
    result = _.floor(result, 1);
    return result;
  }
}
